import type { Indexes, Page, Translation, TranslationsIndexes } from "./common";

export interface AdvertisingTranslation extends Translation {
  filename?: string;
  video_url?: string;
}

export enum StatusEnum {
  ENABLED = "enabled",
  DISABLED = "disabled",
  PAUSED = "paused",
  UNKNOWN = "unknown",
}

type Metadata = Record<string, string>;

export interface AdvertisingPauseAd {
  url: string;
  debounce_ms?: number;
  cooldown_ms?: number;
}

export interface IAdvertisingSingle extends IAdvertising {
  status: StatusEnum;
  offers: {
    uuid: string;
    label: string;
  }[];
  translations_indexes: TranslationsIndexes;
  translations: AdvertisingTranslation[];
  metadata: Metadata;
  filename: string;
  offset_percentage: number;
  params: null | VASTParamsList<string | number>;
  max_duration: number;
  url: string | null;
  skip_video_duration: string | number;
  skip_video: boolean;
  pause_ad?: AdvertisingPauseAd | null;
}

export enum AdvertisingEnum {
  CSAI_MP4 = "csai_mp4",
  CSAI_VAST = "csai_vast",
}

export interface IAdvertising {
  status: StatusEnum;
  uuid: string;
  updated_at: Date;
  type: AdvertisingEnum;
  offer_plans_count: number;
  label: string;
  inserted_at: Date;
}

export type Advertisings = IAdvertising[];

/* VAST */
export type VASTOptionKeys =
  | "content_genre"
  | "country"
  | "max_ads"
  | "max_duration"
  | "min_duration";

export interface VASTOption {
  label: string;
  key: VASTOptionKeys;
  isOptional?: boolean;
  type?: string;
  initialValue?: string | number;
  minValue?: number;
}

export type VASTParamsList<T> = Partial<Record<VASTOptionKeys, T>>;

export type VASTFormChange = (item: {
  key: keyof IAdvertisingSingle;
  value: VASTFormValue;
}) => void;

export type VASTFormValue =
  | number
  | string
  | boolean
  | AdvertisingPauseAd
  | null
  | VASTParamsList<string | number>;

/* FROM API */
export interface IGetAdvertisingResponse {
  type: "advertising";
  page: Page;
  indexes: Indexes;
  data: Advertisings;
}
